import { useEffect, useMemo, useRef, useState } from "react";
import type { EventStatistics } from "../../services/drinkService";

export const useEventStatsUiState = (stats: EventStatistics | null) => {
    const statsRef = useRef(stats);
    statsRef.current = stats;
    const [selectedDrinkId, setSelectedDrinkId] = useState<number | null>(null);
    const [visibleUserIds, setVisibleUserIds] = useState<number[]>([]);

    useEffect(() => {
        const currentStats = statsRef.current;
        if (!currentStats) {
            setVisibleUserIds([]);
            setSelectedDrinkId(null);
            return;
        }
        setVisibleUserIds(currentStats.users.map((participant) => participant.userId));
        setSelectedDrinkId(null);
    }, [stats?.eventId, stats?.users.length]);

    const visibleUserSet = useMemo(() => new Set(visibleUserIds), [visibleUserIds]);
    const allParticipantIds = useMemo(() => stats?.users.map((participant) => participant.userId) ?? [], [stats]);
    const showAllParticipants = allParticipantIds.length > 0 && visibleUserIds.length === allParticipantIds.length;

    return { selectedDrinkId, setSelectedDrinkId, visibleUserIds, setVisibleUserIds,
        visibleUserSet, allParticipantIds, showAllParticipants };
};
